import styled from "styled-components";
import { globalTheme } from "@cld/component-theme";
import { InlineFieldLayout, Label } from "@cld/form";
import { colorPickerTheme } from "@cld/color-picker";

export const SectionBox = styled.section`
	padding: ${globalTheme.spacing.xs};
	border-bottom: 1px solid ${globalTheme.palette.secondary};
	position: relative;
	> label {
		font-weight: bold;
		white-space: nowrap;
		display: block;
		padding-bottom: ${globalTheme.spacing.xs};
	}
	opacity: ${({ disabled }) => disabled ? 0.5 : 1};
	cursor: ${({ disabled }) => disabled ? "not-allowed" : "default"};
`;

export const LastSectionBox = styled(SectionBox)`
	border-bottom: 0px none;
`;

export const InlineFieldLayoutCustomized = styled(InlineFieldLayout)`
	padding-bottom: ${globalTheme.spacing.xs};
`;

export const RadioLabel = styled(Label)`
	padding-top: 1px; // aligment fix
`;

export const ColorPaletteContainer = styled.div`
	margin-left: -${colorPickerTheme.palette.itemSpacing};
`;

